module.exports = __webpack_public_path__ + "img/closed_inbox.872aeba4.svg";